import React, { useEffect, useState } from "react";
import iso from "../../../Gemco-Website-Images/Homepage/iso.png";
import "./Stats.css";

const Counter = ({ target }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const duration = 5000;
    const incrementTime = 20;

    const step = Math.ceil(target / (duration / incrementTime));

    const timer = setInterval(() => {
      start += step;

      if (start >= target) {
        start = target;
        clearInterval(timer);
      }

      setCount(start);
    }, incrementTime);

    return () => clearInterval(timer);
  }, [target]);

  return <span className="counter wa-counter">{count}</span>;
};

const Stats = () => {
  return (
    <div className="stats">
      <div className="container bs-container-2">
        <div className="bs-core-feature-4-line wa-scaleXInUp"></div>

        <div className="bs-core-feature-4-wrap has-5">
          <div className="bs-core-feature-4-item wow fadeInRight">
            <h4 className="bs-h-4 item-title">Years In UAE </h4>
            <br />
            <h5 className="bs-h-4 item-counter" data-cursor="-opaque">
              <span className="counter wa-counter">
                <Counter target={25} />+
              </span>
            </h5>
          </div>
          <div className="bs-core-feature-4-item wow fadeInRight">
            <h4 className="bs-h-4 item-title">Projects Delivered </h4>

            <h5 className="bs-h-4 item-counter" data-cursor="-opaque">
              <span className="counter wa-counter">
                <Counter target={150} />+
              </span>
            </h5>
          </div>
          <div className="bs-core-feature-4-item wow fadeInRight">
            <h4 className="bs-h-4 item-title">Sectors Served </h4>
            <br />
            <h5 className="bs-h-4 item-counter" data-cursor="-opaque">
              <span className="counter wa-counter">5</span>
            </h5>
          </div>
          <div className="bs-core-feature-4-item wow fadeInRight">
            <h4 className="bs-h-4 item-title">Certified Company</h4>

            <h5 className="bs-h-4 item-counter" data-cursor="-opaque">
              <img src={iso} width="250" height="100" alt="" />
              {/* <span className="counter wa-counter">ISO - Certified Details</span> */}
            </h5>
          </div>
        </div>
        <div class="bs-core-feature-4-line wa-scaleXInUp"></div>
      </div>
    </div>
  );
};

export default Stats;
